//
// Helpers
//
// Various helper library functions to assist developers


getRandom = function(size) {
    return Math.floor(Math.random() * size);
}

getRandomWeighted = function(weights, weightsSum) {
	
	var index = -1;
	var randomWeight = getRandom(weightsSum);
	
	do {
		randomWeight -= weights[++index];
	} while (randomWeight >= 0);
	
	return index;
}

checkForUndefined  = function(object, logMessage, fatalError) {
    if (typeof(object) !== "undefined") {
        return false;
    }

    if (typeof(logMessage) === "undefined") {
        return true;
    }

    if (fatalError) {
        console.error(logMessage);
    }
    else {
        console.log(logMessage);
    }

    return true;
}

checkForDefined = function(object, logMessage, fatalError) {
    if (typeof(object) === "undefined") {
        return false;
    }

    if (typeof(logMessage) === "undefined") {
        return true;
    }

    if (fatalError) {
        console.error(logMessage);
    }
    else {
        console.log(logMessage);
    }

    return true;
}